import React, { useEffect, useState } from "react";
import "./CreateNewsLetter.css";
import { FaRegSquarePlus } from "react-icons/fa6";
import { RxCrossCircled } from "react-icons/rx";
import ReactQuill from "react-quill";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteNewsletter,
  createnewsletter,
  getAllNewsletter,
} from "../../actions/newsLetterActions";
import { MdDelete } from "react-icons/md";
import ReactPaginate from "react-paginate";
const CreateNewsLetter = () => {
  const { loading, AllNewsLetter, createletter ,deletedNL} = useSelector(
    (state) => state.newsLetterState
  );
  // console.log(createletter);
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [data, setData] = useState({
    subject: "",
    content: "",
  });
  const handleChange = (value, name) => {
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      await dispatch(createnewsletter(data));
    } catch (error) {
      console.log(error);
    }
  };
  const handleDelete = (id) => {
    dispatch(DeleteNewsletter(id));
  };

  useEffect(() => {
    dispatch(getAllNewsletter);
  }, [createletter, deletedNL, dispatch]);


  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = AllNewsLetter?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil((AllNewsLetter?.length || 0) / itemsPerPage);
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % AllNewsLetter?.length;
    setItemOffset(newOffset);
  };

  const getContent = (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data }} />;
  };
  return (
    <div className="createnewsletter">
      {openPopup && (
        <>
          <div className="cnl-pupup">
            <div className="cnl-pupup_close">
              <RxCrossCircled
                className="icon"
                onClick={() => setOpenPopup(false)}
              />
            </div>
            <form className="cnl-input" onSubmit={handleSubmit}>
              <div className="cnl-input_container">
                <p className="cnl-inpu_lable">Subject</p>
                <input
                  type="text"
                  name="subject"
                  value={data.subject}
                  onChange={(e) => handleChange(e.target.value, "subject")}
                />
              </div>
              <div>
                <p>Content</p>
                <ReactQuill
                  className="cnl-text_area"
                  placeholder="write some thing"
                  formats={CreateNewsLetter.formats}
                  modules={CreateNewsLetter.modules}
                  value={data.content}
                  onChange={(content) => handleChange(content, "content")}
                />
              </div>
              <input
                type="submit"
                value={"submit"}
                style={{ position: "relative" }}
                className="cnl-submit-button"
                disabled={loading}
              />
            </form>
          </div>

          <div className="cnl-pupup-background"></div>
        </>
      )}
      <button
        className="createnewsletter_btn"
        onClick={() => setOpenPopup(true)}
      >
        Create NewsLetter{" "}
        <span>
          <FaRegSquarePlus />
        </span>
      </button>
      <table className="cnl-_table">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>subject</th>
            <th>NEWS Letter</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentItems &&
            currentItems.map((data, index) => {
              return (
                <tr key={data._id}>
                  <td className="query_name">{itemOffset + index + 1}</td>
                  <td className="query_email">{data.subject}</td>
                  <td className="query_content">{getContent(data.content)}</td>
                  <td>
                    <button className="querie_button" onClick={() => handleDelete(data._id)}>
                      <MdDelete className="icon" />
                    </button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
    </div>
  );
};

CreateNewsLetter.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};
CreateNewsLetter.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];
export default CreateNewsLetter;
